import React, { useEffect } from "react";
import "./MealsNutrition.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import mealsImg from "../../Asset/Images/MealsNutrition.png";

const MealsNutrition = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 nutrition support points
  const nutritionPoints = [
    "meals.point1",
    "meals.point2",
    "meals.point3",
    "meals.point4",
    "meals.point5",
    "meals.point6",
    "meals.point7",
    "meals.point8"
  ];

  return (
    <div className="meals_page">
      {/* HERO SECTION */}
      <section className="meals_hero">
        <div className="meals_card_container">
          <div className="meals_content" data-aos="fade-right">
            <span className="service_tag">{t('meals.service_tag')}</span>
            <h1>
              {t('meals.title_start')} <span>{t('meals.title_end')}</span>
            </h1>
            <p>{t('meals.hero_desc')}</p>
          </div>

          <div className="meals_image" data-aos="fade-left">
            <img src={mealsImg} alt={t('meals.title_start') + " " + t('meals.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="meals_details">
        <h2 data-aos="fade-up">{t('meals.details_title')}</h2>
        <div className="meals_grid">
          {nutritionPoints.map((key, index) => (
            <div className="meals_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="meals_cta" data-aos="fade-up">
        <h2>{t('meals.cta_title')}</h2>
        <p>{t('meals.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default MealsNutrition;